/* Cart subscription note (draft). Reads /cart.js and shows when each refill subscription's next delivery is due.
   Works with the theme drawer and common cart apps (Rebuy Smart Cart, UpCart). Re-inserts itself when the cart re-renders. */
(function () {
  var STARTER = 'mighty-starter-pack-v2';
  var SEL = '.rebuy-cart__flyout-items, .rebuy-cart__flyout-body .rebuy-cart__flyout-items, .upcart-products-section, [data-upcart-products], .cart-drawer__items, .cart__items, [data-cart-items]';
  var ROOTS = '.rebuy-cart, #rebuy-cart, .upcart, [id*="upcart"], .cart-drawer, .cart__items, [data-cart-items]';
  var busy = false;
  function fmt(c) { return '\u00a3' + (Math.round(c) / 100).toFixed(2); }
  function addMonths(m) { var d = new Date(); var day = d.getDate(); d.setMonth(d.getMonth() + Math.floor(m)); if (d.getDate() < day) d.setDate(0); var extra = Math.round((m % 1) * 30); if (extra) d.setDate(d.getDate() + extra); return d; }
  function dstr(d) { return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' }); }
  function months(name) { var m = String(name || '').match(/(\d+)\s*(month|week)/i); return m ? (/week/i.test(m[2]) ? +m[1] / 4.345 : +m[1]) : 0; }
  function cadence(name) { var m = String(name || '').match(/(\d+)\s*(month|week)s?/i); if (!m) return ''; return +m[1] === 1 ? 'every ' + m[2].toLowerCase() : 'every ' + m[1] + ' ' + m[2].toLowerCase() + 's'; }
  function esc(t) { var d = document.createElement('div'); d.textContent = String(t == null ? '' : t); return d.innerHTML; }
  function lines(cart) {
    var out = [];
    (cart.items || []).forEach(function (it) {
      var a = it.selling_plan_allocation; if (!a || !a.selling_plan) return;
      var off = a.compare_at_price && a.compare_at_price > a.price ? Math.round((a.compare_at_price - a.price) / a.compare_at_price * 100) : 0;
      if (it.handle === STARTER || it.product_handle === STARTER) {
        out.push('<strong>Your refills subscription</strong> starts ' + esc(dstr(addMonths(1))) + ', then 3 refills are delivered every 3 months' + (off ? ' with ' + off + '% discount' : '') + '.');
        return;
      }
      var m = months(a.selling_plan.name); if (!m) return;
      out.push('<strong>Your refills subscription</strong> will start ' + esc(dstr(addMonths(m))) + ' and you pay ' + esc(fmt(a.price * it.quantity)) + ' + shipping. Delivery ' + esc(cadence(a.selling_plan.name)) + (off ? ' with ' + off + '% discount' : '') + '.');
    });
    return out.join('<br>');
  }
  function box(html) {
    var el = document.createElement('div');
    el.className = 'mstarter-cartnote';
    el.setAttribute('data-html', html);
    el.setAttribute('style', 'display:flex;gap:10px;align-items:flex-start;background:#f1f4fb;border-radius:12px;padding:12px 14px;margin:12px 16px;font-size:14px;line-height:1.45;color:#072660;text-align:left');
    el.innerHTML = '<span aria-hidden="true" style="font-size:18px;line-height:1.2">\u267b\ufe0f</span><span>' + html + '</span>';
    return el;
  }
  function place(html) {
    document.querySelectorAll(SEL).forEach(function (t) {
      if (t.parentElement && t.parentElement.closest(SEL)) return;
      var n = t.nextElementSibling, has = n && n.classList.contains('mstarter-cartnote');
      if (!html) { if (has) n.remove(); return; }
      if (has) { if (n.getAttribute('data-html') !== html) n.replaceWith(box(html)); return; }
      t.insertAdjacentElement('afterend', box(html));
    });
  }
  function update() {
    if (busy || !document.querySelector(SEL)) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) { place(lines(cart)); })
      .catch(function () {}).then(function () { busy = false; });
  }
  var timer = null;
  function soon() { clearTimeout(timer); timer = setTimeout(update, 200); }
  function relevant(node) { return node && node.nodeType === 1 && !node.closest('.mstarter-cartnote') && (node.closest(ROOTS) || (node.querySelector && node.querySelector(SEL))); }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (relevant(muts[i].target)) { soon(); return; }
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) if (relevant(added[j])) { soon(); return; }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  ['rebuy:cart.change', 'rebuy:cart.ready', 'rebuy:smartcart.show', 'rebuy:smartcart.line-item-increase', 'rebuy:smartcart.line-item-decrease', 'rebuy:smartcart.line-item-removed', 'upcart:cart-updated', 'cart:updated'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(update, 300); }); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
})();